export default __webpack_public_path__ + "static/media/404ERROR.3f4d7fda.jpg";